// Communities as soft pill chips — same ink-on-paper register as the
// detail surface, no chip border colour beyond the hairline rule.
// Plural-aware kicker so single-community hearings don't read awkward.
export function CommunitiesSection({ communities }: { communities: string[] }) {
  if (communities.length === 0) return null;

  return (
    <section className="ph-detail-panel" aria-label="Affected communities">
      <h2 className="ph-detail-panel-l">
        <span>
          Affected communit{communities.length === 1 ? "y" : "ies"}
        </span>
        <span className="count">{communities.length}</span>
      </h2>
      <div className="ph-detail-communities">
        {communities.map((c) => (
          <span key={c} className="ph-detail-community-chip">
            {c}
          </span>
        ))}
      </div>
    </section>
  );
}
